export const DISCARD_LABEL_CHANGES_MODAL_LABELS = {
	TITLE: 'Discard unsaved changes?',
	BODY: "Your changes haven't been saved and will be lost.",
	DISCARD: 'Discard',
	KEEP_EDITING: 'Keep Editing'
} as const;
